export enum TableIdType {
  CustomersTable = 'customers-table',
  PromoCustomersTable = 'promo-customers-table',
  CustomersEventsTable = 'customers-events-table',
  BrandsOffersTable = 'brands-offers-table',
  EventsTable = 'events-table',
  CampaignsTable = 'campaigns-table',
  UsersTable = 'users-table',
  AmbassadorLocationsTable = 'ambassador-locations-table',
  LocationsTable = 'locations-table',
  LocationAdminsTable = 'location-admins-table',
  TiersTable = 'tiers-table',
  OffersNotificationsTable = 'offers-notifications-table',
  OrganizationConfigurationsTable = 'organization-configurations-table',
  BrandsTable = 'brands-table',
  AllOffersTable = 'all-offers-table',
  LocationCategoriesTable = 'location-categories-table',
  VendorOfferCategoriesTable = 'vendor-offer-categories-table',
  VendorAudiencesTable = 'vendor-audiences-table',
  OfferCategoriesTable = 'offer-categories-table',
  MerchantOffersTable = 'merchant-offers-table',
  MerchantBrandsOffersTable = 'merchant-brands-offers-table',
  MerchantLocationOffersTable = 'merchant-location-offers-table',
  AmbassadorOffersTable = 'ambassador-offers-table',
  AmbassadorCodesTable = 'ambassador-codes-table',
  AmbassadorOffersFromMerchantsTable = 'ambassador-offers-merchants-table',
  AmbassadorOffersFromBrandsTable = 'ambassador-offers-brands-table',
  RolesUsersTable = 'roles-users-table',
  UsersOffersTable = 'users-offers-table',
  AdminOffersTable = 'admin-offers-table',
  VendorLocationsTable = 'vendor-locations-table',
  VendorsTable = 'vendors-table',
  AmbassadorsTable = 'ambassadors-table',
  BrandsNotificationsTable = 'brands-notifications-table',
  BrandsConfigurationsTable = 'brands-configurations-table',

  MerchantLocationsRequestsTable = 'merchant-locations-requests-table',
  MerchantLocationsCreateTable = 'merchant-locations-create-table',
  AdminLocationsRequestsTable = 'admin-locations-requests-table',
  AdminLocationsCreateRequestsTable = 'admin-locations-create-requests-table',

  MerchantEditLocationsTable = 'merchant-locations-edit-table',
  AdminEditLocationsTable = 'admin-locations-edit-table',

  MerchantEditBrandRequestsTable = 'merchant-brand-edit-requests-table',
  AdminEditBrandRequestsTable = 'admin-brand-edit-requests-table',

  MarketManagementTable = 'market-management-table',
  MarketZipCodesTable = 'market-zip-codes-table',
  VendorMarketsTable = 'vendor-markets-table',
}
